import { API_URL } from "../../constants";

export const getRewardCode = async () => {
  return new Promise((resolve, reject) => {
    return fetch(`${API_URL}/commercial/rewardCode/all`)
      .then(async (response) => {
        if (response.status === 200) {
          const data = await response.json();
          resolve(data);
        } else {
          const message = await response.json();
          reject({ ...message });
        }
      })
      .catch((err) => {
        console.error("catch", err);
        return err;
      });
  });
};

export const createRewardCode = async (data) => {
  return new Promise((resolve, reject) => {
    return fetch(`${API_URL}/commercial/rewardCode/create`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        if (response.status === 200) {
          const data = await response.json();
          resolve(data);
        } else {
          const message = await response.json();
          reject({ ...message });
        }
      })
      .catch((err) => {
        console.error("catch", err);
        return err;
      });
  });
};

export const updateRewardCode = async (data) => {
  return new Promise((resolve, reject) => {
    return fetch(`${API_URL}/commercial/rewardCode`, {
      method: "PUT",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify(data),
    })
      .then(async (response) => {
        if (response.status === 200) {
          const data = await response.json();
          resolve(data);
        } else {
          const message = await response.json();
          reject({ ...message });
        }
      })
      .catch((err) => {
        console.error("catch", err);
        return err;
      });
  });
};
